/**
 * AuditoriaObservacaoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {AuditoriaObservacao} from '@/model/resource/AuditoriaObservacao'

/* TODO: review generated class */
@HttpExclude()
export class AuditoriaObservacaoCollection extends PageCollection<
  AuditoriaObservacao
> {
  constructor() {
    super(AuditoriaObservacao)
  }

  queryAsPage() {
    return this.listAuditoriaObservacao()
  }

  async listAuditoriaObservacao() {
    return await Request.get(`/admin/auditoria-observacao`, {
      params: this.params,
    })
      .name('listAuditoriaObservacao')
      .as(this)
      .getResponse()
  }

  async listCsvAuditoriaObservacao() {
    return await Request.get(`/admin/auditoria-observacao/csv`, {
      params: this.params,
    })
      .name('listCsvAuditoriaObservacao')
      .as(this)
      .getResponse()
  }
}
